!(function () {
  'use strict';

  const API_RELATED_TEMPLATE = '[data-api-related-template]';
  const RECENTLY_VIEWED_ITEM = '.product-item, .featured-product-card';
  const DATA_GRID_ITEM = '[data-grid-item]';
  const DATA_RELATED_SECTION = '[data-related-section]';
  const RECENTLY_VIEWED_TAG = 'recently-viewed';
  const DATA_RECENTLY_VIEWED_WRAPPER = '[data-recently-viewed-wrapper]';
  const ATTR_LIMIT = 'data-limit';
  const ATTR_PRODUCT_ID = 'data-product-id';
  const CLASS_HIDDEN = 'hidden';
  const MOBILE_MAX = 749;

  function isRelatedTabsMobile() {
    return typeof window.matchMedia === 'function' && window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  /**
   * Mobile: scroll tab strip so the active label is fully visible — tab 0 at start, last tab at end (right-aligned in view).
   */
  function alignRelatedProductTabs(relatedProductsEl) {
    if (!relatedProductsEl || !isRelatedTabsMobile()) return;
    const tabsRoot = relatedProductsEl.querySelector('tabs-component.related__products--tabs-enabled');
    if (!tabsRoot) return;
    const scrollEl = tabsRoot.querySelector('ul[data-scrollbar].related-product-tabs');
    const active = tabsRoot.querySelector('.tab-link.current');
    if (!scrollEl || !active || active.classList.contains(CLASS_HIDDEN)) return;

    const tabIdx = parseInt(active.getAttribute('data-tab'), 10);
    const maxScroll = Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);

    let target = 0;
    if (tabIdx <= 0) {
      target = 0;
    } else {
      target = active.offsetLeft + active.offsetWidth - scrollEl.clientWidth;
      target = Math.max(0, Math.min(target, maxScroll));
    }

    scrollEl.scrollTo({ left: target, behavior: 'smooth' });
  }

  function initCarouselIfPresent(relatedSectionEl) {
    const root = relatedSectionEl && relatedSectionEl.closest('[data-featured-carousel-root]');
    if (root && typeof window.initFeaturedCollectionCarousel === 'function') {
      window.initFeaturedCollectionCarousel(root);
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define(
      'related-products',
      class extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.id;
          this.relatedItems = 0;
          this.wrapper = this.querySelector(DATA_RECENTLY_VIEWED_WRAPPER);
          this.recentlyViewed = this.querySelector(RECENTLY_VIEWED_TAG);
        }

        connectedCallback() {
          this.loadRelatedProducts();
          this.loadRecentlyViewedProducts();
          this.bindRelatedTabsMobileScroll();
        }

        bindRelatedTabsMobileScroll() {
          const tabsRoot = this.querySelector('tabs-component.related__products--tabs-enabled');
          if (!tabsRoot) return;

          const run = () => {
            requestAnimationFrame(() => alignRelatedProductTabs(this));
          };

          tabsRoot.addEventListener('theme:tab:change', run);
          tabsRoot.addEventListener('theme:tab:check', run);
          document.addEventListener('theme:resize', run);

          run();
          setTimeout(run, 100);
          setTimeout(run, 400);
        }

        loadRelatedProducts() {
          const el = this.querySelector(DATA_RELATED_SECTION);
          if (!el) return;
          const productId = el.getAttribute(ATTR_PRODUCT_ID);
          const limit = el.getAttribute(ATTR_LIMIT);
          const url = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=related`;
          fetch(url)
            .then((r) => r.text())
            .then((html) => this.handleRelatedProductsResponse(html, el))
            .catch(() => this.hideSection(el));
        }

        handleRelatedProductsResponse(html, relatedSectionEl) {
          const wrapper = document.createElement('div');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const template = doc.querySelector(API_RELATED_TEMPLATE);
          if (!template) {
            this.hideSection(relatedSectionEl);
            this.updateVisibility();
            return;
          }
          wrapper.innerHTML = template.innerHTML;
          const count = wrapper.querySelectorAll(DATA_GRID_ITEM).length;
          if (count > 0) {
            relatedSectionEl.innerHTML = wrapper.innerHTML;
            this.relatedItems = count;
            initCarouselIfPresent(relatedSectionEl);
          } else {
            this.hideSection(relatedSectionEl);
          }
          this.updateVisibility();
        }

        loadRecentlyViewedProducts() {
          if (!this.recentlyViewed) return;
          this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
            this.handleRecentlyViewedResponse();
          });
        }

        handleRecentlyViewedResponse() {
          const minimum = parseInt(this.recentlyViewed.dataset.minimum, 10) || 1;
          const items = this.recentlyViewed.querySelectorAll(RECENTLY_VIEWED_ITEM);
          const showWithoutTabs = !this.wrapper && items.length > 0;
          const showWithTabs = this.wrapper && items.length >= minimum;
          if (showWithoutTabs || showWithTabs) {
            if (showWithTabs && this.wrapper) {
              this.wrapper.classList.remove(CLASS_HIDDEN);
            }
            this.recentlyViewed.classList.remove(CLASS_HIDDEN);
            this.recentlyViewed.dispatchEvent(new CustomEvent('theme:tab:check', { bubbles: true }));
            initCarouselIfPresent(this.recentlyViewed);
          }
          this.updateVisibility();
        }

        hideSection(el) {
          el.dispatchEvent(new CustomEvent('theme:tab:hide', { bubbles: true }));
        }

        updateVisibility() {
          const noRecent =
            typeof Shopify !== 'undefined' &&
            Shopify.Products &&
            Shopify.Products.getConfig().howManyToShow < 1 &&
            this.relatedItems < 1;
          this.classList.toggle(CLASS_HIDDEN, noRecent);
        }
      }
    );
  }
})();
